"use strict";

var BlsComparePageShopify = (function () {
  return {
    initCompareItems: function () {
      this.init();
    },

    init: function () {
      let compare_items = [];
      try {
        const stored = JSON.parse(localStorage.getItem("glozin__compare-items"));
        if (Array.isArray(stored)) compare_items = stored.map(String).filter((id) => /^\d+$/.test(id)).slice(0, 50);
      } catch (_) {}
      const compareDiv = document.querySelector(".compare-page-main");
      if (!compareDiv) return;
      const div_no_product = compareDiv.querySelector(".compare-no-product-js");
      if (compare_items.length === 0) {
        div_no_product.classList.remove("hidden");
      } else {
        const query = compare_items.join("%20OR%20id:");
        const section_id = document.querySelector(".compare-page-section")
          .dataset.sectionId;
        var productAjaxURL =
          "?section_id=" +
          section_id +
          "&type=product&options[unavailable_products]=last&q=id:" +
          query;
        fetch(`${window.routes.search_url}${productAjaxURL}`)
          .then((response) => {
            if (!response.ok) throw new Error("Could not load comparison products");
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, "text/html");
            const table = compareDiv.querySelector(".compare-table");
            const products = html.querySelectorAll(".compare-page-section > .product-compare");
            if (!table || !products.length) {
              div_no_product.classList.remove("hidden");
              return;
            }
            const rowNames = ["basic", "name", "price", "personality",
              "family", "concentration", "top", "heart", "base", "gender",
              "season", "occasion", "description",
              "size", "availability"];
            table.querySelectorAll(".compare-value").forEach((cell) => cell.remove());
            products.forEach((product) => {
              rowNames.forEach((name) => {
                const source = product.querySelector(`.compare-row-${name}`);
                const target = table.querySelector(`.compare-row-${name}`);
                if (source && target) target.insertAdjacentHTML("beforeend", source.innerHTML);
              });
            });
            table.classList.remove("hidden");
          })
          .catch((e) => {
            console.error(e);
            div_no_product.classList.remove("hidden");
          })
      }
    },
  };
})();
BlsComparePageShopify.initCompareItems();

class CompareRemove extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.productId = this.dataset.productId;
    this.productHandle = this.dataset.productHandle;
    this.init();
  }
  init() {
    this.setAttribute("role", "button");
    this.tabIndex = 0;
    this.setAttribute("aria-label", this.dataset.removeLabel || "إزالة من المقارنة");
    this.addEventListener("click", this.onThisClick.bind(this));
    this.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.onThisClick();
      }
    });
  }
  onThisClick() {
    const localListProductIds = localStorage.getItem("glozin__compare-items");
    const allThisProductIds = document.querySelectorAll(
      `compare-remove[data-product-id="${this.productId}"]`
    );
    let listProductIds = [];
    if (!this.productId) return;
    if (localListProductIds && allThisProductIds.length > 0) {
      // compare localstorage exists
      let parseLocalListProductIds;
      try {
        const stored = JSON.parse(localListProductIds);
        parseLocalListProductIds = Array.isArray(stored) ? stored.map(String) : [];
      } catch (_) {
        parseLocalListProductIds = [];
      }
      const indexOfProductId = parseLocalListProductIds.indexOf(
        this.productId
      );
      if (indexOfProductId === -1) return;
      parseLocalListProductIds.splice(indexOfProductId, 1);
      listProductIds.push(...parseLocalListProductIds);
      const product_remove = document.querySelectorAll(
        `[data-product-handle="${this.productHandle}"]`
      );
      product_remove.forEach((e) => {
        e.remove();
      });
      if (parseLocalListProductIds.length === 0) {
        const compareDiv = document.querySelector(".compare-page-main");
        const div_no_product = compareDiv.querySelector(".compare-no-product-js");
        const compare_table = compareDiv.querySelector(".compare-table");
        div_no_product.classList.remove("hidden");
        compare_table?.classList.add("hidden");
      }
    }
    const stringifyListProductIds = JSON.stringify(listProductIds);
    localStorage.setItem("glozin__compare-items", stringifyListProductIds);
    if (typeof compareHeader !== "undefined") compareHeader.init();
  }
}
customElements.define("compare-remove", CompareRemove);
